module.exports = __webpack_public_path__ + "img/dummy-img-400x400.26a010b7.jpg";